import React, { useEffect, useState } from 'react'

const useToken = () => {

const[token,SetToken]=useState('')


   useEffect(() => {
    SetToken(JSON.parse(localStorage.getItem('auth')))
   }, [])
   
  return [token]
}

export default useToken